import { render, staticRenderFns } from "./RulesList.vue?vue&type=template&id=1062fda6&scoped=true&"
import script from "./RulesList.vue?vue&type=script&lang=tsx&"
export * from "./RulesList.vue?vue&type=script&lang=tsx&"
import style0 from "./RulesList.vue?vue&type=style&index=0&id=1062fda6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1062fda6",
  null
  
)

export default component.exports